module.exports = __webpack_public_path__ + "static/media/icon.eda8f956.png";